import React, { Component } from 'react';

import socket from '../../utils/socket';
import AuthContext from '../../contexts/AuthContext';
import { fetchContacts, fetchMessages, sendMessage, getEmojiRecommendations } from '../../utils/sideEffects';
import { encryptMessage, decryptMessage } from '../../utils/AES';

import ChatWindow from '../../components/Message/ChatWindow';
import ContactWindow from '../../components/Message/ContactWindow';
import NewMessage from '../../components/Message/NewMessage';
import Spinner from '../../components/UI/Spinner';
import Modal from '../../components/UI/Modal';

class Chat extends Component {

    static contextType = AuthContext;

    state = {
        contactWindowOpen: false,
        contacts: [],
        activeContact: null,
        isLoadingMessages: false,
        messages: null,
        emojiRecommendations: null,
        isLoadingContacts: true,
        error: null,
    }

    getContactsHandler = async () => {
        const result = await fetchContacts();
        if (result.status !== 200) {
            this.setState({ error: result.data, isLoadingContacts: false });
        } else {
            const contacts = []
            result.data.contacts.forEach(contact => {
                contacts.push({
                    ...contact,
                    ['lastMessage']: { ...contact.lastMessage, ['text']: decryptMessage(contact.lastMessage.text) }
                })
            });
            this.setState({ contacts: contacts, isLoadingContacts: false });
        }
    }

    activeContactChangeHandler = async (userId) => {
        this.setState({ isLoadingMessages: true });
        const result = await fetchMessages(userId);
        if (result.status !== 200) {
            this.setState({
                error: result.data,
                isLoadingMessages: false
            });
        } else {
            this.setState(prevState => {
                const contacts = [...prevState.contacts];
                const activeContactIndex = contacts.findIndex(contact => contact.userId === userId);
                const activeContact = { ...contacts[activeContactIndex] };
                const lastMessage = { ...activeContact.lastMessage };
                lastMessage.isRead = true;
                activeContact.lastMessage = lastMessage;
                contacts[activeContactIndex] = activeContact;
                const messages = result.data.messages.map(message => {
                    return {
                        ...message, ['text']: decryptMessage(message.text)
                    }
                });
                return {
                    isLoadingMessages: false,
                    contacts: contacts,
                    activeContact: activeContact,
                    messages: messages,
                }
            });
        }
    }

    sendMessageHandler = async (messageText) => {
        const message = {
            from: {
                userId: this.context.userId,
                firstName: this.context.firstName,
                lastName: this.context.lastName
            },
            to: this.state.activeContact,
            text: encryptMessage(messageText),
            isRead: false,
            timestamp: Date.now(),
        }
        const result = await sendMessage(message);
        if (result.status !== 200) {
            this.setState({ error: result.data });
        } else {
            socket.emit('sendMessage', { message: message });
            const contacts = [...this.state.contacts];
            const activeContactIndex = contacts.findIndex(contact => contact.userId === message.to.userId);
            const activeContact = { ...contacts[activeContactIndex] };
            const lastMessage = { ...activeContact.lastMessage };
            lastMessage.isRead = true;
            lastMessage.text = messageText;
            activeContact.lastMessage = lastMessage;
            contacts[activeContactIndex] = activeContact;
            this.setState(prevState => { return { messages: [...prevState.messages, { ...message, ['text']: messageText }], contacts: contacts } });
        }
    }

    emojiRecommendationClickHandler = async (event, message) => {
        event.preventDefault();
        const result = await getEmojiRecommendations(message);
        if (result.status !== 200)
            this.setState({ error: result.data });
        else {
            this.setState({ emojiRecommendations: result.data.recommendations.map(r => r.toString(16)) });
        }
    }

    clearEmojiRecommendationHadler = () => {
        this.setState({ emojiRecommendations: null });
    }

    contactWindowOpenHandler = () => {
        this.setState({ contactWindowOpen: true });
    }

    contactWindowCloseHandler = () => {
        this.setState({ contactWindowOpen: false });
    }

    modalCloseHandler = () => {
        this.setState({ error: null });
    }

    componentDidMount() {
        socket.emit('join', { userId: this.context.userId });
        this.getContactsHandler();
        socket.on('message', ({ message }) => {
            message = { ...message, ['text']: decryptMessage(message.text) };
            if (this.state.activeContact && this.state.activeContact.userId === message.from.userId) {
                const contacts = [...this.state.contacts];
                const activeContactIndex = contacts.findIndex(contact => contact.userId === this.state.activeContact.userId);
                const activeContact = { ...contacts[activeContactIndex] };
                const lastMessage = { ...activeContact.lastMessage };
                lastMessage.isRead = true;
                lastMessage.text = message.text;
                activeContact.lastMessage = lastMessage;
                contacts[activeContactIndex] = activeContact;
                this.setState(prevState => { return { messages: [...prevState.messages, message], contacts: contacts } });
            } else {
                const contacts = [...this.state.contacts];
                const activeContactIndex = contacts.findIndex(contact => contact.userId === message.from.userId);
                const activeContact = { ...contacts[activeContactIndex] };
                const lastMessage = { ...activeContact.lastMessage };
                lastMessage.isRead = false;
                lastMessage.text = message.text;
                activeContact.lastMessage = lastMessage;
                contacts[activeContactIndex] = activeContact;
                this.setState({ contacts: contacts });
            }
        })
    }

    componentWillUnmount() {
        socket.emit('endSession', { userId: this.context.userId });
        socket.off('join');
        socket.off('message');
    }

    render() {
        let messageModule = (
            <div className="message-module">

                <Modal show={this.state.error !== null} title="An error occurred!" closed={this.modalCloseHandler} >
                    {this.state.error && <p>{this.state.error.status}: {this.state.error.message}</p>}
                </Modal>

                <div className="contact-header">
                    <button className="contact-window-toggle" onClick={this.contactWindowOpenHandler}>
                        <i className="fa fa-users" aria-hidden="true"></i>
                    </button>
                    <p className="contact-name">{this.state.activeContact && this.state.activeContact.firstName}</p>
                </div>

                <ContactWindow
                    open={this.state.contactWindowOpen}
                    closed={this.contactWindowCloseHandler}
                    contacts={this.state.contacts}
                    activeContactUserId={this.state.activeContact ? this.state.activeContact.userId : null}
                    contactClicked={this.activeContactChangeHandler} />

                <div className="message-area">
                    <ChatWindow
                        isUserSelected={this.state.activeContact !== null}
                        isLoading={this.state.isLoadingMessages}
                        messages={this.state.messages}
                        currentUser={this.context.userId} />
                    <NewMessage
                        disabled={!this.state.activeContact}
                        emojiRecommendations={this.state.emojiRecommendations}
                        send={this.sendMessageHandler}
                        clicked={this.emojiRecommendationClickHandler}
                        cleared={this.clearEmojiRecommendationHadler} />
                </div>

            </div>
        );

        if (this.state.isLoadingContacts) {
            messageModule = <Spinner />;
        }

        return messageModule;
    }
}

export default Chat;